<template>
  <van-search
        v-model="keyword"
        background="#fe3a33"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        @search="onSearch"
      >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
</template>

<script>
export default {
  data () {
    return {
      keyword:''  //搜索词
    }
  },
  methods:{
    onSearch(){
      this.$emit('onSearch',this.keyword)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/search.vue